import { PencilSquareIcon } from "@heroicons/react/24/solid";

const EditButtonVendorVoice = ({
  buttonText = "Edit",
  className = "",
  onClick,
  disabled = false,
  isForLongText = false,
}) => {
  return (
    <button
      value={buttonText}
      onClick={onClick}
      disabled={disabled}
      type="button"
      className={
        (disabled
          ? `cursor-not-allowed border text-white bg-quaternary opacity-25 py-3 px-4 gap-x-2 `
          : `bg-quaternary border-quaternary text-white hover:text-white  `) +
        `hover:scale-90 bg-quaternary shadow-md h-7 lg:h-6 gap-2 whitespace-pre border-quaternary text-white 
        hover:border-hquinary hover:bg-hquaternary hover:text-white flex flex-row items-center justify-center 
        text-xs border rounded-full transition duration-500 ease select-none focus:outline-none
         focus:shadow-outline undefined ${
           isForLongText ? `px-4` : `w-20 lg:w-20 `
         } ${className}`
      }
    >
      <PencilSquareIcon className="h-4 w-4" />
      <div className="-mt-auto">{buttonText}</div>
    </button>
  );
};

export default EditButtonVendorVoice;
